import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import Button from '@material-ui/core/Button';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

const ALLOWED_RETURN_ROUTES = new Set([
  '/admin-dashboard',
  '/customers',
  '/accomodations',
  '/groups',
  '/events',
  '/ferrys',
  '/discount-codes',
  '/organization',
  '/products',
  '/admins',
  '/emails',
]);

const AdminBackButton = ({ to, label = 'Back', state, className }) => {
  const history = useHistory();
  const location = useLocation();
  const returnTo = ALLOWED_RETURN_ROUTES.has(location.state?.from)
    ? location.state.from
    : to;

  const handleClick = () => {
    history.replace({
      pathname: returnTo,
      state,
    });
  };

  return (
    <Button
      className={className}
      color="default"
      variant="outlined"
      startIcon={<ArrowBackIcon />}
      onClick={handleClick}
    >
      {label}
    </Button>
  );
};

export default AdminBackButton;
